/// <amd-module name="TFS/Admin/Views/GitHubConnection/redux/GitHubConnectionModule" />
import { AnyAction, ReducersMapObject } from "redux";
import { ISagaModule } from "redux-dynamic-modules-saga";
import { IGitHubConnectionAwareState, IGitHubConnectionState } from "TFS/Admin/Views/GitHubConnection/Contracts";
import { gitHubConnectionReducer } from "TFS/Admin/Views/GitHubConnection/redux/GitHubConnectionReducers";
import { GitHubConnectionSaga } from "TFS/Admin/Views/GitHubConnection/redux/GitHubConnectionSaga";

export function getGitHubConnectionModule(): ISagaModule<IGitHubConnectionAwareState> {
    const reducerMap: ReducersMapObject<IGitHubConnectionAwareState, AnyAction> = {
        gitHubConnectionState: gitHubConnectionReducer
    };

    return {
        id: "gitHubConnectionState",
        reducerMap,
        sagas: [GitHubConnectionSaga]
    };
}
